import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import API from '../utils/API';
import LoginModal from '../components/LoginModal';
import './confirmRegistration.css';

export default function ConfirmRegistration() {
    const { token } = useParams();
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        API.confirmRegistraionEmail(token)
            .then(res => setStatus(res.data.success ? 'success' : 'error'))
            .catch(() => setStatus('error'));
    }, [token]);

    return (
        <>
            <div className="cr-page">
                <div className="cr-card">
                    <div className="cr-card-header">
                        <div className="cr-brand">
                            <i>'ello</i><span>Govna</span>
                        </div>
                    </div>

                    <div className="cr-card-body">
                        {status === 'loading' && (
                            <>
                                <div className="cr-spinner" />
                                <p className="cr-loading-text">Confirming your email&hellip;</p>
                            </>
                        )}

                        {status === 'success' && (
                            <>
                                <div className="cr-icon-wrap">
                                    <i className="bi bi-check2-circle" />
                                </div>
                                <h1 className="cr-heading">Email Confirmed!</h1>
                                <p className="cr-sub">
                                    Your <strong>'elloGovna</strong> account is active. Sign in to get started
                                    and join the Sacramento policy community.
                                </p>
                                <button
                                    className="cr-btn"
                                    data-bs-toggle="modal"
                                    data-bs-target="#loginModal"
                                >
                                    Sign In
                                </button>
                            </>
                        )}

                        {status === 'error' && (
                            <>
                                <div className="cr-icon-wrap cr-icon-wrap--error">
                                    <i className="bi bi-exclamation-circle" />
                                </div>
                                <h1 className="cr-heading">Link Expired or Invalid</h1>
                                <p className="cr-sub">
                                    This confirmation link has expired or has already been used. If you
                                    haven't confirmed your account yet, please register again or contact{' '}
                                    <a href="mailto:info@ellogovna.com" style={{ color: '#458da1' }}>
                                        info@ellogovna.com
                                    </a>{' '}
                                    for help.
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <footer className="cr-footer">
                <span>&copy; <em>'ello</em>Govna {new Date().getFullYear()}</span>
            </footer>

            <LoginModal />
        </>
    );
}
